var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "call"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.94577 5.56998C8.01559 6.5055 8.19015 7.41999 8.46945 8.29244L7.07297 9.55381C6.59585 8.29244 6.29328 6.95749 6.18854 5.56998H7.94577ZM19.4201 18.2047C20.4093 18.457 21.4217 18.6146 22.4458 18.6777V20.2439C20.9097 20.1493 19.4318 19.876 18.0237 19.4556L19.4201 18.2047ZM9.06295 3.4677H4.9899C4.34985 3.4677 3.82617 3.94071 3.82617 4.51884C3.82617 14.3891 12.6821 22.3882 23.6096 22.3882C24.2496 22.3882 24.7733 21.9152 24.7733 21.3371V17.6686C24.7733 17.0905 24.2496 16.6175 23.6096 16.6175C22.1665 16.6175 20.7584 16.4073 19.455 16.0183C19.3387 15.9763 19.2107 15.9658 19.0943 15.9658C18.7917 15.9658 18.5008 16.0709 18.268 16.2706L15.7078 18.5831C12.4145 17.059 9.71464 14.6308 8.03887 11.6561L10.5991 9.34358C10.9249 9.04926 11.018 8.63931 10.89 8.27142C10.4594 7.09414 10.2267 5.83277 10.2267 4.51884C10.2267 3.94071 9.703 3.4677 9.06295 3.4677Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.95ad6e1c323e55a2a98af2dad711674e.svg";
export { ForwardRef as ReactComponent };